import { useCallback, useMemo } from 'react';
import { useSet } from 'react-use';

import { PeerFeedbackTemplateFragment } from '@/modules/corporate/modules/feedback/graphql/fragments/generated/FeedbackTemplate';

interface Params {
  feedbackTemplate?: PeerFeedbackTemplateFragment[];
}

const useTemplateSidebar = (params: Params) => {
  const { feedbackTemplate } = params;
  const [sectionIndexSet, { toggle }] = useSet<number>();

  const sections = useMemo(() => {
    return feedbackTemplate?.map((feedback) => ({
      id: feedback.id,
      label: feedback.name,
      items: feedback.templates.map((v) => ({ id: v.text, label: v.text })),
    }));
  }, [feedbackTemplate]);

  const onAccordionChange = useCallback(
    (_expanded: boolean, index: number) => {
      toggle(index);
    },
    [toggle],
  );

  const contents = useMemo(
    () =>
      sections?.map((section, index: number) => {
        const open = !sectionIndexSet.has(index);

        return {
          ...section,
          open: open,
          items: open ? section.items : [],
        };
      }),
    [sectionIndexSet, sections],
  );

  return { contents, onAccordionChange };
};

export default useTemplateSidebar;
